var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dataRender && _vm.dataRender.show
    ? _c(
        "v-footer",
        {
          staticClass: "white--text safari-footer",
          attrs: { color: _vm.dataRender.color, height: "56", app: "" },
        },
        [
          _vm.dataRender.buttons.show
            ? _c(
                "div",
                { staticClass: "d-flex justify-content-center w-full" },
                [
                  _vm._l(_vm.dataRender.buttons.items, function (item, index) {
                    return [
                      (item.icon || item.icon == "") && !item.round
                        ? _c(
                            "v-btn",
                            {
                              key: "icon-" + index,
                              staticClass: "m-1",
                              attrs: {
                                text: "",
                                icon: "",
                                disabled: item.disabled,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.tab(item)
                                },
                              },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: item.icon, color: item.color },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.round
                        ? _c(
                            "v-btn",
                            {
                              key: "button-" + index,
                              staticClass: "m-1",
                              style: { color: _vm.dataRender.color },
                              attrs: {
                                rounded: "",
                                color: item.color,
                                light: "",
                                disabled: item.disabled,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.tab(item)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n        " + _vm._s(item.label) + "\n      "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.spacer
                        ? _c("v-spacer", { key: "spacer-" + index })
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.dataRender.default.show
            ? _c(
                "div",
                { staticClass: "p-3 d-flex justify-content-center" },
                [
                  _c("span", [_vm._v("Vuetify")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("span", [_vm._v("© 2017")]),
                ],
                1
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }